import { useQuery } from "@tanstack/react-query";
import type { ID } from "../../data/BaseEntity";
import { getCustomerOrdersStatistics } from "../customersApi";

export const useCustomerOrdersStats = (customerId: ID, year: number) => {
  const { data, isLoading } = useQuery({
    queryKey: ["customers", customerId, "order-stats", { year }],
    queryFn: ({ signal }) => getCustomerOrdersStatistics(customerId, year, signal),
  });
  return { ordersStats: data, isLoading };
};
